import React, { useCallback, useState, useEffect } from 'react';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { getScreens, updateScreen, updateOrder } from '../../actions';
import style from './ScreenList.module.css';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { ScreenItem } from './ScreenItem';

const _ScreenList = SortableContainer(
  ({ screens, onChange }: { screens: Cockpit.Screen[]; onChange(option: string, id: string, value: any): Promise<any> }) => {
    return (
      <div className={style.wrapper}>
        <div className={style.container}>
          {screens.map((screen, index) => {
            return <ScreenItem key={screen.id} index={index} value={screen} onChange={onChange} />;
          })}
        </div>
      </div>
    );
  }
);

function _ScreenListContainer({ screens, loading, dispatch }: { screens: Cockpit.Screen[]; loading: boolean; dispatch: Cockpit.dispatch }) {
  useEffect(() => {
    dispatch(getScreens());
  }, []);

  const onChange = useCallback(
    (option: 'name' | 'publish' | 'thumb', id: string, value: any) => dispatch(updateScreen({ option, id, value })),
    [screens]
  );

  const changeSort = ({ oldIndex, newIndex }: { oldIndex: number; newIndex: number }) => {
    dispatch(updateOrder({id: screens[oldIndex].id, oldIndex, newIndex}))
  };

  if(loading) return null;
  if(!screens.length) 
    return <div className={style['list--empty']}><a className={style['list--empty__text']}>暂无可用大屏</a></div>

  return <_ScreenList screens={screens} onChange={onChange} onSortEnd={changeSort} axis='xy' useDragHandle />;
}

export const ScreenList = connect<any, any, any, Cockpit.Store>(store => ({ screens: store.screens, loading: store.screensLoading }))(_ScreenListContainer);
